export function promiseLimit(concurrency) {
  if (!Number.isInteger(concurrency) || concurrency <= 0) {
    throw new TypeError("A concorrência deve ser um número inteiro positivo");
  }

  const queue = [];
  let activeCount = 0;

  // Função interna que avança a fila quando uma tarefa termina
  const next = () => {
    activeCount--;
    if (queue.length > 0) {
      const task = queue.shift();
      task(); // Executa a próxima tarefa da fila
    }
  };

  // Função interna que executa a Promise e gerencia seu estado
  const run = async (fn, resolve, reject, args) => {
    activeCount++;
    try {
      // O "await" garante que funções síncronas também funcionem
      const result = await fn(...args);
      resolve(result);
    } catch (error) {
      reject(error);
    } finally {
      // Independentemente de sucesso ou erro, libera o espaço para a próxima
      next();
    }
  };

  // A função retornada que o usuário chamará para adicionar tarefas
  const generator = (fn, ...args) => {
    return new Promise((resolve, reject) => {
      const task = () => run(fn, resolve, reject, args);

      // Se ainda temos espaço no limite, executamos imediatamente
      if (activeCount < concurrency) {
        task();
      } else {
        // Caso contrário, enviamos para a fila de espera
        queue.push(task);
      }
    });
  };

  // Métodos utilitários extras (iguais aos do p-limit original)
  Object.defineProperties(generator, {
    activeCount: { get: () => activeCount },
    pendingCount: { get: () => queue.length },
    clearQueue: {
      value: () => {
        queue.length = 0;
      },
    },
  });

  return generator;
}
